import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import { Col, Row } from 'react-bootstrap';

import useBeforeUnload from 'hooks/useBeforeUnload';
import AppContext from 'config/app-context';

import Section from 'components/common/Section';
import Header from './header/Header';
import WizardEmet from './wizard/WizardEmet';

import { certificationActions } from 'store/slices/certification/certificationSilce';

import {
	fetchCertificationById, 
	generateCertificationError, 
	updateCertificationCompletedById, 
	updateCertificationStatusById
} from 'api/certifications/certifications';

import { fetchUsers } from 'api/users/users';

import { fetchColleges } from 'api/colleges/colleges';

import { handleApiError } from 'utils';
import DisableCopyPasteDevTools from 'hooks/disableCopyPasteDevTools';
import useExamFocusGuard from 'hooks/useExamFocusGuard';


const CertificationEmet = () => {
	const token = useSelector(state => state.authentication.user?.token);
	const username = useSelector(state => state.authentication.user?.username);
	const { step } = useSelector(state => state.certificationReducer);

	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();

	const {config, setConfig} = useContext(AppContext);
	const certification = location.state;

	useBeforeUnload();
	
	useEffect(() => {
		if (!certification) navigate('/');
	}, [certification, navigate]);


	useEffect(() => {
		if (token !== null && token !== undefined)  {
			loadCertificationById();
		}
	}, [token]);


	useEffect(() => {
		if (config.isFullscreen !== true) {
			setConfig('isFullscreen', true);
		}
		return() => {
			if (config.isFullscreen !== false) {
				setConfig('isFullscreen', false);
			}
		};
	}, [setConfig, config.isFullscreen]);


	useEffect(() => {
        if (sessionStorage.getItem('reloading')) {
            sessionStorage.removeItem('reloading');
			let data = { status: 5 }
            handleUpdateCertificationStatusById(data);
        }
    }, []);

	const { violationCount, resetGuard } = useExamFocusGuard(
		
		(count) => {
			if (count === 4) {
				handleUpdateCertificationStatusById({ status: 4 });
				resetGuard();
			}
		},
		() => {
			handleUpdateCertificationStatusById({ status: 4 });
			resetGuard();
		},
		step,
		certification.certification_type  // puede ser 'epst' o 'emet'
	);

	const handleUserByUsername = async () => {
		try {
			const { data } = await fetchUsers({ username: encodeURIComponent(username) }, token);
			handleCollegeById(data);
		} catch (error) {
			handleApiError(error);
		}
	};


	const handleCollegeById = async (user) => {
		try {
			const { data } = await fetchColleges({ id: certification.college_id }, token);
			handleUpdateCertificationCompletedById(user, data);
			
		} catch (error) {
			handleApiError(error);
		}
	};

	const loadCertificationById = async () => {
		try {
			const { data } = await fetchCertificationById(certification.id, token);
			if (data?.status === 200) {
				if (data.message.status > 1) certificationNotAvaible();
			}
		} catch (error) {
			handleApiError(error);
		}
	};


	const handleUpdateCertificationCompletedById = async (user, college) => {
		try {
			const timeZone = moment.tz.guess();
			const currentDate = moment().tz(timeZone).format('YYYY-MM-DD HH:mm:ss');
			let date = { completed_date: currentDate }
			const response = await updateCertificationCompletedById(certification.id, date, token);
			if(response) {
				let data = {
					name: `${user.name} ${user.lastname}`,
					college: college.name,
					email: user.email,
					certification: "EMeT",
					date: currentDate
				}
				handleGenerateCertificationError(data);
			}
		} catch (error) {
			handleApiError(error);
		}
		console.log("Se cancelo el examen por recargar la page");
	};


	const handleGenerateCertificationError = async(data) => {
		try {
			const response = await generateCertificationError(data, token);
			console.log(response);
			if(response.data.status === 200) {
				dispatch(certificationActions.resetCertification()); 
				navigate('/');
			} 
		} catch (error) {
			handleApiError(error);
		}
	}


	const handleUpdateCertificationStatusById = async (data) => {
		try {
			await updateCertificationStatusById(certification.id, data, token);
			handleUserByUsername();
		} catch (error) {
			handleApiError(error);
		}
	};


	const certificationNotAvaible = () => {
		Swal.fire({
			title: "Error",
			text: "Esta certificación no esta disponible.",
			icon: "error",
			showCancelButton: false,
			showCloseButton: false,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			reverseButtons: true
		}).then((result) => {
			if (result.isConfirmed) {
				navigate('/');
			}
		}).catch(() => {
			return false;
		})
	}
	

	return (
		<>
			<DisableCopyPasteDevTools />
			<Section fluid className="py-0 fullscreen">
				<div className="container">
					<Row className="justify-content-center">
						<Col lg={11} xxl={11} className="py-3">
							<Header  /> 
							<WizardEmet
                                variant="pills"
                                validation={true}
                                progressBar={true}
								certification={certification} />            
						</Col>
					</Row>
				</div>
			</Section>
		</>
	);

};

export default CertificationEmet;
